import { LegalLayout, LegalSection } from "../component/legal/LegalLayout";
import { siteConfig } from "../config/site";

export function KycAmlPolicyPage() {
  return (
    <LegalLayout
      eyebrow="Policies"
      title="KYC & AML Policy"
      description={`How ${siteConfig.companyName} verifies customer identity and prevents money laundering.`}
    >
      <LegalSection heading="Background">
        <p>
          {siteConfig.companyName} (the "Company") has adopted this Know
          Your Customer (KYC) and Anti-Money Laundering (AML) Policy in
          accordance with the Reserve Bank of India's Master Direction on
          KYC, and the Prevention of Money Laundering Act, 2002 (PMLA), as
          amended from time to time. The policy is designed to prevent the
          Company's platform from being used, intentionally or
          unintentionally, for money laundering, terrorist financing, or
          other illegal activities.
        </p>
      </LegalSection>

      <LegalSection heading="Customer Identification Procedure">
        <p>
          Before onboarding any customer, the Company verifies identity and
          address using Officially Valid Documents (OVDs) such as Aadhaar,
          PAN, passport, voter ID, or driving licence. Identity is further
          confirmed through methods such as OTP-based e-KYC, Video KYC, or
          in-person verification, as applicable. The Company does not
          process a loan application until the customer's identity has been
          satisfactorily verified.
        </p>
      </LegalSection>

      <LegalSection heading="Customer Risk Categorization">
        <p>
          Customers are categorized as low, medium, or high risk based on
          factors such as their income profile, source of funds, nature of
          transactions, and geographical location. Higher-risk customers
          are subject to enhanced due diligence, including more frequent
          reviews of their KYC information.
        </p>
      </LegalSection>

      <LegalSection heading="Ongoing Due Diligence">
        <p>
          The Company periodically updates and re-verifies customer
          information to ensure it remains current and accurate, in line
          with RBI's KYC guidelines. Customers may be asked to reconfirm or
          resubmit documents from time to time, particularly where
          transaction patterns or risk profiles change.
        </p>
      </LegalSection>

      <LegalSection heading="Monitoring & Reporting of Suspicious Transactions">
        <p>
          The Company monitors transactions for unusual or suspicious
          patterns that may indicate money laundering or fraud. Where
          required, the Company reports such transactions to the Financial
          Intelligence Unit – India (FIU-IND) in accordance with applicable
          law. A Principal Officer is designated to oversee compliance with
          this policy and coordinate reporting obligations.
        </p>
      </LegalSection>

      <LegalSection heading="Record Keeping">
        <p>
          The Company maintains records of customer identification data and
          transaction information for the period prescribed under
          applicable law, and makes such records available to regulatory or
          law enforcement authorities upon lawful request.
        </p>
      </LegalSection>

      <LegalSection heading="Employee Training">
        <p>
          Employees involved in customer onboarding and transaction
          monitoring receive periodic training on KYC/AML requirements,
          red-flag indicators, and the Company's internal reporting
          procedures.
        </p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>
          For questions about this policy, please reach out
          {siteConfig.email ? (
            <>
              {" "}
              at{" "}
              <a
                href={`mailto:${siteConfig.email}`}
                className="font-semibold text-brand-purple underline"
              >
                {siteConfig.email}
              </a>
            </>
          ) : null}
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
